<script>
import TextField from '@/components/base/TextField'

import VTextField from 'vuetify/es5/components/VTextField/VTextField'
import VMenu from 'vuetify/es5/components/VMenu/VMenu'
import VDatePicker from 'vuetify/es5/components/VDatePicker/VDatePicker'

export default {
    name: 'DatePicker',
    extends: TextField,
    props: {
        min: String,
        max: String,
        menuRight: Boolean,
        menuLeft: Boolean,
        type: {
            type: String,
            default: 'date'
        },
        locale: {
            type: String,
            default: "it"
        }
    },
    created () {
        this.isEdge = this.$bowser.satisfies({ 'microsoft edge': '>0' })
    },
    data: () => ({
        isMenuActive: false,
        isEdge: false,
        pressedTab: false
    }),
    methods: {
        onClick (e) {
            //  Per compatibilità con firefox e IE
            e.preventDefault()
            VTextField.options.methods.onClick.call(this)
            this.pressedTab = false
        },
        onBlur (e) {
            VTextField.options.methods.onBlur.call(this, e)
            if (this.pressedTab) {
                //  Questo mi permette di chiudere il menu solo se passo ad un altro input con TAB
                this.isMenuActive = false
                this.pressedTab = false
            }
        },
        onKeyDown (e) {
            VTextField.options.methods.onKeyDown.call(this, e)
            if (e.which === 9 || e.keyCode === 9) { //  Tasto TAB
                this.pressedTab = true
            }
        },
        genInput () {
            let input = VTextField.options.methods.genInput.call(this)
             if (this.type === 'month' && !this.isEdge) {
                input.data.attrs.type = 'text'     // ← HTML input diventa <input type="text">
                input.data.domProps = input.data.domProps || {}
                input.data.domProps.value = this.formattedValue // 👈 LOCALIZZATO
            }
            input.data.attrs.readonly = (this.type === 'month' && !this.isEdge)
            input.data.attrs.class += ` ${this.validationState}--text` //  Per cambiare il colore anche del testo dell'input in caso di errore
            return input
        },
        genPicker () {
            let _this = this
            return this.$createElement(VDatePicker, {
                props: {
                    locale: this.locale,
                    noTitle: true,
                    firstDayOfWeek: 1,
                    type: this.type,
                    scrollable: true,
                    min: this.min,
                    max: this.max,
                    value: this.internalValue,
                },
                on: {
                    input (val) {
                        _this.internalValue = val
                        setTimeout(() => {
                            _this.isMenuActive = false
                        })
                    }
                },
                nativeOn: {
                    click (e) {
                        _this.pressedTab = false
                    }
                }
            })
        },
        genMenu () {
            let _this = this
            return this.$createElement(VMenu, {
                ref: 'menu',
                props: {
                    //  Uso il picker di sistema con Edge
                    activator: this.isEdge ? null : this.$refs['input-slot'],
                    light: true,
                    closeOnContentClick: false,
                    transition: 'scale-transition',
                    fullWidth: true,
                    minWidth: '290px',
                    disabled: this.disabled,
                    right: this.menuRight,
                    left: this.menuLeft,
                    offsetX: this.menuRight || this.menuLeft,
                    offsetY: true,
                    value: this.isMenuActive
                },
                on: {
                    input (val) {
                        _this.isFocused = val
                        _this.isMenuActive = val
                    }
                }
            }, [this.genPicker()])
        },
        genDefaultSlot () {
            return [this.$createElement('div', {
                staticClass: 'v-text-field__slot'
            }, [this.genLabel(), this.prefix ? this.genAffix('prefix') : null, this.genInput(), this.suffix ? this.genAffix('suffix') : null, this.genClearIcon(), this.genIconSlot()]
            ),
            this.genMenu()]
        }
    },
    computed: {
        rules () {
            let rules = this.required ? [this.$utils.rules.required, ...this.vRules] : this.vRules
            return rules.concat([
                v => !v || !this.min || v >= this.min || this.$t('errori.data_min'),
                v => !v || !this.max || v <= this.max || this.$t('errori.data_max')])
        },
        formattedValue () {
            if (!this.internalValue || this.type !== 'month') return this.internalValue

            const [year, month] = this.internalValue.split('-')
            const date = new Date(parseInt(year), parseInt(month) - 1)

            return new Intl.DateTimeFormat(this.locale, {
            year: 'numeric',
            month: 'long'
            }).format(date)
        }
    },
    watch: {
        locale () {
            this.$forceUpdate()
        }
    }
}
</script>
<style scoped lang="scss">
  .v-input--is-focused {
    .v-text-field__prefix {
      color: rgba(0, 0, 0, .87);
    }
  }

  .v-text-field__slot {
    .v-text-field__prefix, input {
      cursor: text !important;
    }
  }
</style>
